import useMediaQuery from '@mui/material/useMediaQuery';
const usePhoneSize = () => {
  const size = useMediaQuery('(max-width: 760px)');
  return size;
}

export default usePhoneSize;